import { Loader } from 'component/Loader/Loader'
import { observer } from 'mobx-react-lite'
import { Page } from 'page/Page/Page'
import { opt } from 'store/opt'

type Props = {
  start?: boolean
}

export const LoadingPage = observer(({ start }: Props) => {
  const back = start || opt.close_back

  return <Page full center noBack={!back}>
    <Loader />
  </Page>
})
